<template>
  <div class="item">
    <div class="head">
      <span style="padding-left: 37px">قیمت واحد</span>
      <span>مقدار</span>
      <span>قیمت کل</span>
    </div>

    <div v-if="!sellOrderBook.length && !buyOrderBook.length" class="noData">
      <p class="text-no-data">
        There is no information to display
      </p>
    </div>


    <div class="true-show" v-if="sellOrderBook !== null &&  buyOrderBook !== null ">

      <div class="buy">
        <div v-for="(item , index2) in sellOrderBook" :key="index2"
             :style="{backgroundImage:`linear-gradient(-90deg  , rgba(207, 102, 121, 0.2) ${item.executedPercent}%, transparent ${item.executedPercent}%)`}"
             class="prog">
          <div style="color: #D94F68">{{ item.unitPrice.toLocaleString() }}</div>
          <div>{{ item.executedAmount.toLocaleString() }}</div>
          <div>{{ item.wholePrice.toLocaleString() }}</div>
        </div>
      </div>

      <div class="border">
        <p class="total">40,555.971</p>
        <div class="line">
          <img src="../../../assets/public/Line2.png" alt="">
        </div>
      </div>

      <div class="sell">
        <div v-for="(item , index) in buyOrderBook" :key="index[0]"
             :style="{backgroundImage:`linear-gradient(-90deg  , rgba(110, 174, 168, 0.2) ${item.executedPercent}%, transparent ${item.executedPercent}%)`}"
             class="prog">
          <div style="color: rgba(4, 178, 162, 1)">{{ item.unitPrice.toLocaleString() }}</div>
          <div>{{ item.executedAmount.toLocaleString() }}</div>
          <div>{{ item.wholePrice.toLocaleString() }}</div>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: "deep-trade",

//------------------------------------Data

  data() {
    return {

      type: "",

      sellOrderBook: [
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 40},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 50},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 50},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 60},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 70},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 80},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 90},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 100},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 20},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 40},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 25},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 70},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 80},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 90},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 100},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 20},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 40},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 25},
      ],

      buyOrderBook: [
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 40},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 50},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 50},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 60},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 70},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 80},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 90},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 100},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 20},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 40},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 25},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 70},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 80},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 90},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 100},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 20},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 30},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 40},
        {unitPrice: 254185125, executedAmount: 52512515, wholePrice: 1515141, executedPercent: 25},
      ]
    }
  },
}

</script>

<style lang="scss" scoped>
.item {
  width: 100%;
  direction: rtl;
  max-height: 745px;

  .head {
    margin-bottom: 10px;
  }
}

.head {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  text-align: center;

  span {
    color: #D7C8C8;
    font-size: small;
  }
}

.buy{
  height: 330px;
  overflow: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.sell{
  height: 330px;
  overflow: auto;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.true-show{
  display: flex;
  flex-direction: column;
  max-height: 745px;
  overflow: hidden;
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}

.prog {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  margin-bottom: 0;
  color: rgba(72, 77, 86, 1);
  font-size: clamp(10px, 2.5vw, 12px);
  height: 24px;
  color: #D7C8C8;
  align-items: center;

  div {
    background-color: transparent;
    flex-grow: 1;
    display: flex;
    justify-content: space-around;
  }
}

.totla {
  text-align: center;
  color: rgb(74, 163, 113);
  font-weight: 600;
}

.noData {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.text-no-data {
  color: #D7C8C8;
  font-size: clamp(12px, 2vw, 16px);
  font-weight: bold;
}

.border {
  width: 100%;
  display: flex;
  justify-content: start;
  align-items: center;

  .line {
    width: 80%;

    img{
      width: 65%;
    }
  }

  .totla {
    color: rgba(4, 178, 162, 1);
    width: 20%;
  }
}
</style>